const veneer = {
  fontFamily: 'Veneer',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `local('Veneer'), local('Veneer-Regular'), url('/themes/custom/takis/assets/fonts/Veneer.woff2') format('woff2')`,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

const futuraStd = {
  fontFamily: 'FuturaStd',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `local('FuturaLt'), local('FuturaLt-Condensed'), url('/themes/custom/takis/assets/fonts/FuturaLT-Condensed.woff2') format('woff2')`,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

const roboto = {
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `local('Roboto'), local('Roboto-Regular'), url('/themes/custom/takis/assets/fonts/Roboto.woff2') format('woff2')`,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

export const fontFaces = [
  veneer,
  futuraStd,
  roboto,
]
